<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("add_waste_items") }}
      </h1>
    </div>

    <!-- Form Section -->
    <div
      class="px-6 py-4"
      v-if="
        $store.getters['checkUserAccess']({
          id: '13',
          action: 'add',
        })
      "
    >
      <div class="">
        <form @submit="addSaleItem">
          <div class="grid gap-x-6 mb-6 md:grid-cols-2">
            <div class="mb-5">
             
              <DropdownInput
                v-model="i_id"
                :label="$t('wasted_item')"
                :items="convertToListIdValueItem"
                :placeholder="$t('choose_item')"
                :rules="rules_dropdown"
                :isError="checkRulesIsError(i_id, 'add', this.rules_dropdown).isError"
                :errorMsg="checkRulesIsError(i_id, 'add', this.rules_dropdown).errorMsg"
                @change="updateSelectedItem"
              />
            </div>

            <DropdownInput
              v-model="cawt_id"
              :label="$t('waste_category')"
              :items="convertToListIdValueWasteCategory"
              :placeholder="$t('choose_waste_category')"
              :rules="rules_dropdown"
              :isError="
                checkRulesIsError(cawt_id, 'add', this.rules_dropdown).isError
              "
              :errorMsg="
                checkRulesIsError(cawt_id, 'add', this.rules_dropdown).errorMsg
              "
              linkDrop="/item-waste-category"
            />
            <div class="mb-5">
            
              <DropdownInput
                v-model="pui_id"
                :label="$t('purchases')"
                :items="convertToListIdValuePurchases"
                :placeholder="$t('choose_purchase')"
                :rules="rules_dropdown"
                :isError="checkRulesIsError(pui_id, 'add', this.rules_dropdown).isError"
                :errorMsg="checkRulesIsError(pui_id, 'add', this.rules_dropdown).errorMsg"
              />
            </div>

            <BaseInput
              v-model="wt_quantity"
              :label="$t('waste_quantity')"
              :placeholder="$t('waste_quantity')"
              type="number"
              :rules="rules"
              :isError="checkRulesIsError(wt_quantity, 'add').isError"
              :errorMsg="checkRulesIsError(wt_quantity, 'add').errorMsg"
            />
            <TextAreaInput
              v-model="wt_note"
              :label="$t('note')"
              :placeholder="$t('note')"
              :rules="rules"
              :isError="checkRulesIsError(wt_note, 'add').isError"
              :errorMsg="checkRulesIsError(wt_note, 'add').errorMsg"
            />
          </div>

          <ButtonInput
            type="button"
            @click="addSaleItem"
            :label="$t('add')"
            :isLoading="isBtnLoading"
          />
        </form>
      </div>
    </div>
  </div>
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      (isHide == true
        ? '  '
        : $store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
    id="printDev"
    v-if="
      $store.getters['checkUserAccess']({
        id: '13',
        action: 'view',
      })
    "
  >
    <InvoiceHeader invoice_type="wasted_items_list" v-if="isHide == true" />
    
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("waste_items_list") }}
      </h1>
    </div>

    <!-- Table Container -->
    <div class="px-6 py-4">
   
      <div
        class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden"
      >
        <div class="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700 no-print">
            <div class="flex items-center space-x-4">
              <BaseInput
                :modelValue="$store.state.waste_item.search"
                @update:modelValue="handleSearchInput"
                :placeholder="$t('search')"
                :prefixIcon="'fa-solid fa-search'"
                class="w-40 md:w-full"
              /> <button
                class="mx-2 my_font bg-primaryColor hover:bg-blue-700 text-white font-bold py-1 px-4 rounded no-print"
                @click="printReportFunc"
                id="button_print"
                v-if="$store.getters['checkPrintAccess']"
              >
                {{ $t("print") }}
              </button>
            </div>
            
            <!-- Column Selection and Controls -->
            <div class="flex items-center space-x-4">
              <CustomMultiSelect
                v-model="selectedHeaders"
                :options="headers"
                track-by="value"
                label="text"
                :placeholder="$t('columns')"
                :header-text="$t('which_columns_to_display')"
                @update:modelValue="printCall"
              />
              <div class="w-0.5"></div>
              <button
                @click="resetToDefaultHeaders"
                class="group inline-flex items-center justify-center w-10 h-10 bg-gradient-to-br  text-blue-600 dark:text-blue-400 rounded-xl border border-blue-200 dark:border-gray-600 hover:from-blue-100 hover:to-indigo-200 dark:hover:from-gray-600 dark:hover:to-gray-700 hover:shadow-lg hover:shadow-blue-200/50 dark:hover:shadow-gray-900/50 hover:scale-105 active:scale-95 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 backdrop-blur-sm"
                :title="$t('reset_to_default')"
              >
                <i class="fa fa-refresh text-sm group-hover:rotate-180 transition-transform duration-500"></i>
              </button>
             
            </div>
          </div>
      
          <EasyDataTable
            :key="`table-${isDark ? 'dark' : 'light'}`"
            v-model:server-options="serverOptions"
            :headers="showHeaders"
            :items="items"
            :server-items-length="serverItemsLength"
            :loading="isLoadingData"
            :alternating="false"
            :buttons-pagination="true"
            :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
            :hide-footer="isHide"
            :rows-items="[25, 50, 100, serverItemsLength]"
            rows-per-page="10"
            :table-class-name="isDark ? 'modern-dark-table' : ''"
          >
            <template #default="{ column, sortDirection }">
              <div
                :class="`flex items-center space-x-2 ${
                  $store.getters['isRtl'] ? 'justify-end' : 'justify-start'
                }`"
              >
                <span class="font-semibold text-gray-700 dark:text-gray-300">{{
                  column.label
                }}</span>
                <span v-if="column.sortable" class="text-gray-400">
                  <i
                    v-if="sortDirection === 'asc'"
                    class="fa-solid fa-arrow-up text-blue-500"
                  ></i>
                  <i
                    v-else-if="sortDirection === 'desc'"
                    class="fa-solid fa-arrow-down text-blue-500"
                  ></i>
                  <i v-else class="fa-solid fa-arrows-up-down text-gray-400"></i>
                </span>
              </div>
            </template>
            <template #item-actions="item">
              <div class="flex items-center justify-center space-x-2">
                <button
                  @click="showModal(item)"
                  v-if="
                    $store.getters['checkUserAccess']({
                      id: '13',
                      action: 'edit',
                    })
                  "
                  class="inline-flex items-center p-2 text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors duration-200"
                  :title="$t('edit')"
                >
                  <i class="fa-solid fa-pen text-sm"></i>
                </button>
                <button
                  @click="deleteItem(item.wt_id)"
                  v-if="
                    $store.getters['checkUserAccess']({
                      id: '13',
                      action: 'delete',
                    })
                  "
                  class="inline-flex items-center p-2 text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors duration-200"
                  :title="$t('delete')"
                >
                  <i class="fa-solid fa-trash text-sm"></i>
                </button>
              </div>
            </template>
            <template #item-wt_sale_price_jwmla="item">
              <div class="text-right">
                <span class="font-semibold text-gray-900 dark:text-gray-100">
                  {{ formatNumber(item.wt_sale_price_jwmla) }}
                </span>
              </div>
            </template>
            <template #item-wt_cost_price="item">
              <div class="text-right">
                <span class="font-semibold text-gray-900 dark:text-gray-100">
                  {{ formatNumber(item.wt_cost_price) }}
                </span>
              </div>
            </template>
            <template #item-wt_sale_price="item">
              <div class="text-right">
                <span class="font-semibold text-gray-900 dark:text-gray-100">
                  {{ formatNumber(item.wt_sale_price) }}
                </span>
              </div>
            </template>
            <template #item-wt_main_currency_price="item">
              <div class="text-right">
                <span class="font-semibold text-gray-900 dark:text-gray-100">
                  {{ formatNumber(item.wt_main_currency_price) }}
                </span>
              </div>
            </template>
            <template #item-currency_cur_name="item">
              <span
                class="inline-flex items-center px-2 py-1 text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200 rounded-md"
              >
                {{ $t(item.currency.cur_name) }}
              </span>
            </template>
            <template #loading>
              <div class="flex justify-center items-center py-8">
                <div
                  class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
                ></div>
                <span class="ml-3 text-gray-600 dark:text-gray-400"
                  >{{ $t("loading") }}...</span
                >
              </div>
            </template>
            <template #item-created_at="item">
              <span class="text-gray-600 dark:text-gray-400 text-sm">
                {{ formatDate(item.created_at) }}
              </span>
            </template>
            <template #empty-message>
              <div class="text-center py-12">
                <i class="fa-solid fa-box-open text-4xl text-gray-400 mb-4"></i>
                <p class="text-gray-500 dark:text-gray-400 text-lg font-medium">
                  {{ $t("no_data_found") }}
                </p>
                <p class="text-gray-400 dark:text-gray-500 text-sm mt-2">
                  {{ $t("try_adjusting_your_search_criteria") }}
                </p>
              </div>
            </template>

            <template
              #pagination="{
                prevPage,
                nextPage,
                isFirstPage,
                isLastPage,
                currentPaginationNumber,
                maxPaginationNumber,
              }"
            >
              <button :disabled="isFirstPage" @click="goToPage(1)">
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-double-right'
                      : ' fa-angle-double-left')
                  "
                ></i>
              </button>
              <div class="w-5"></div>
              <button :disabled="isFirstPage" @click="prevPage">
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-right'
                      : ' fa-angle-left ')
                  "
                ></i>
              </button>
              <div class="w-5"></div>
              <button
                v-for="page in getVisiblePages(
                  currentPaginationNumber,
                  maxPaginationNumber
                )"
                :key="page"
                @click="goToPage(page)"
                :class="getPageButtonClasses(page, currentPaginationNumber)"
              >
                {{ page }}
              </button>

              <div class="w-5"></div>
              <button :disabled="isLastPage" @click="nextPage">
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-left'
                      : ' fa-angle-right')
                  "
                ></i>
              </button>
              <div class="w-5"></div>
              <button
                :disabled="isLastPage"
                @click="goToPage(maxPaginationNumber)"
              >
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-double-left'
                      : ' fa-angle-double-right')
                  "
                ></i>
              </button>
            </template>
          </EasyDataTable>
        </div>
      </div>
    </div>

  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit="editItem">
        <DropdownInput
          v-model="current.cawt_id"
          :label="$t('waste_category')"
          :items="convertToListIdValueWasteCategory"
          :placeholder="$t('choose_waste_category')"
          :rules="rules_dropdown"
          :isError="
            checkRulesIsError(current.cawt_id, 'edit', this.rules_dropdown)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.cawt_id, 'edit', this.rules_dropdown)
              .errorMsg
          "
        />

        <TextAreaInput
          v-model="current.wt_note"
          :label="$t('note')"
          :placeholder="$t('note')"
          :rules="rules"
          :isError="checkRulesIsError(current.wt_note, 'edit').isError"
          :errorMsg="checkRulesIsError(current.wt_note, 'edit').errorMsg"
        />
        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div>
  </edit-modal>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import CustomMultiSelect from "../../components/Inputs/CustomMultiSelect.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import { formatDate } from "../../utils/functions";
import { formatNumber } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import EditModal from "../../components/Modals/EditModal.vue";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import "../../assets/css/modern-table.css";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    CustomMultiSelect,
    ButtonInput,
    ConfirmDialogue,
    ResultDialog,
    EditModal,
    TextAreaInput,
    DropdownInput,
    InvoiceHeader,
  },
  data() {
    return {
      firstName: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      wt_quantity: "",
      wt_note: "",
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      cawt_id: "",
      i_id: "",
      pui_id: "",
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 12,
      },
      loading: false,
      items: [],
      isHide: false,
      selectedHeaders: [],
      columnsControl: false,
      purchases: [],
    };
  },
  mounted() {
    // First load when the component is mounted
    this.loadFromServer();
    this.loadSelectedHeaders();
  },
  created() {
    this.$store.dispatch("item_waste_category/getWasteCategorys");
    //item_list/getPurchasedItems

    if (
      this.$store.getters["checkUserAccess"]({
        id: "13",
        action: "view",
      })
    ) {
      this.$store.dispatch("item_list/getItemsData");
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.waste_item.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.waste_item.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("waste_item/SET_DELETE_SUCCESS", false);
      }
    },
    serverOptions: {
      handler() {
        this.loadFromServer();
      },
      deep: true,
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.waste_item.isShowResultDialog;
    },

    filterItems() {
      return this.$store.getters["waste_item/filterItems"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.waste_item.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.waste_item.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.waste_item.isBtnEditLoading;
    },
    headers() {
      var listHeader = [
        { text: "#", value: "wt_id", sortable: true },
        {
          text: this.$t("item_barcode"),
          value: "item.i_barcode",
          sortable: true,
        },
        { text: this.$t("item_name"), value: "item.i_name", sortable: true },
        {
          text: this.$t("purchase_id"),
          value: "pu_id",
          sortable: true,
        },
        {
          text: this.$t("waste_category"),
          value: "category_waste_item.cawt_name",
          sortable: true,
        },
        {
          text: this.$t("cost_item_price"),
          value: "wt_cost_price",
          sortable: true,
        },
        {
          text: this.$t("sale_item_price"),
          value: "wt_sale_price",
          sortable: true,
        },
        {
          text: this.$t("wholesale_item_price"),
          value: "wt_sale_price_jwmla",
          sortable: true,
        },
        {
          text: this.$t("currency"),
          value: "currency_cur_name",
          sortable: true,
        },
        {
          text: this.$t("item_quantity"),
          value: "wt_quantity",
          sortable: true,
        },
        {
          text: this.$t("dolar_price_when_item_purchased"),
          value: "wt_main_currency_price",
          sortable: true,
        },
        { text: this.$t("note"), value: "wt_note", sortable: true },
        { text: this.$t("admin"), value: "users.name", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];

      return listHeader;
    },
    showHeaders() {
      var temp = [];
      //cretae a for check all selectedHeaders add to temp
      for (let i = 0; i < this.selectedHeaders.length; i++) {
        for (let j = 0; j < this.headers.length; j++) {
          if (this.selectedHeaders[i].text == this.headers[j].text) {
            temp.push(this.headers[j]);
          }
        }
      }

      if (temp.length == 0) {
        temp = this.headers;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.selectedHeaders = temp;
      }

      return temp;
    },
    convertToListIdValueWasteCategory() {
      var wasteCategorys = this.$store.state.item_waste_category.wasteCategorys;
      var list = [];
      for (const item of wasteCategorys) {
        list.push({
          id: item.cawt_id,
          value: item.cawt_name,
        });
      }

      return list;
    },
    convertToListIdValuePurchases() {
      var purchases = this.purchases;
      var list = [];
      for (const item of purchases) {
        list.push({
          id: item.pui_id,
          value:
            this.$t("purchase_id") +
            "  " +
            item.pu_id +
            " - " +
            this.$t("remain") +
            "  " +
            (item.pui_quantity - item.pui_out_quantity) +
            " - " +
            this.$t("cost") +
            "  " +
            this.formatNumber(item.pui_cost_price) +
            " " +
            (item.cur_id == 2 ? "$" : "IQD"),
        });
      }

      return list;
    },
    convertToListIdValueItem() {
      var itemsData = this.$store.state.item_list.itemsData;
      var list = [];
      for (const item of itemsData) {
        list.push({
          id: item.i_id,
          value: item.i_name,
        });
      }

      return list;
    },
  },

  methods: {
    handleSearchInput(value) {
      this.$store.commit('waste_item/SET_SEARCH', value);
      this.loadFromServer();
      this.serverOptions.page = 1;
    },
    loadSelectedHeaders() {
      // Load selected headers from localStorage
      const savedHeaders = localStorage.getItem("wasteItemSelectedHeaders");
      if (savedHeaders) {
        try {
          const parsedHeaders = JSON.parse(savedHeaders);
          // Filter to only include headers that exist in current headers list
          this.selectedHeaders = this.headers.filter((header) =>
            parsedHeaders.some((saved) => saved.value === header.value)
          );
        } catch (error) {
          console.error("Error loading saved headers:", error);
          this.selectedHeaders = [...this.headers];
        }
      } else {
        // If no saved headers, select all by default
        this.selectedHeaders = [...this.headers];
      }
    },
    saveSelectedHeaders() {
      // Save selected headers to localStorage
      try {
        localStorage.setItem(
          "wasteItemSelectedHeaders",
          JSON.stringify(this.selectedHeaders)
        );
      } catch (error) {
        console.error("Error saving headers:", error);
      }
    },
    printCall(selectedHeaders) {
      // Handle column selection changes
      if (selectedHeaders && Array.isArray(selectedHeaders)) {
        this.selectedHeaders = selectedHeaders;
        this.saveSelectedHeaders();
      }
    },
    resetToDefaultHeaders() {
      // Reset to select all headers
      this.selectedHeaders = [...this.headers];
      this.saveSelectedHeaders();
    },
    async getPurchases() {
      var res = await this.$store.dispatch("item_list/getPurchasedItems", {
        i_id: this.i_id,
      });

      this.purchases = res.data;
    },
    printReportFunc() {
      this.isHide = true;
      //wait 1 second
      setTimeout(() => {
        var printContents = document.getElementById("printDev").innerHTML;

        // Replace the body's innerHTML with the print contents
        document.body.innerHTML = printContents;
        var isRtl = this.$store.getters["isRtl"];
        // Set direction based on the parameter
        if (isRtl) {
          document.body.style.direction = "rtl";
        } else {
          document.body.style.direction = "ltr";
        }

        // Print the content
        window.print();
         // Adjust the timeout as needed
        //reload page
      }, 100);
      //print element id invoice_print
    },
    getVisiblePages(currentPage, totalPages) {
      const numVisibleButtons = 3; // Adjust this number based on your design preference
      const pages = [];

      // Display pages 1 to numVisibleButtons (e.g., 1, 2, 3)
      if (currentPage <= Math.floor(numVisibleButtons / 2) + 1) {
        for (let i = 1; i <= Math.min(totalPages, numVisibleButtons); i++) {
          pages.push(i);
        }
      }
      // Display pages around the current page (e.g., 1, ..., 10, ..., 20)
      else {
        const startPage = Math.max(
          1,
          currentPage - Math.floor(numVisibleButtons / 2)
        );
        const endPage = Math.min(totalPages, startPage + numVisibleButtons - 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }

      return pages;
    },

    // Function to get Tailwind CSS classes for each page button
    getPageButtonClasses(page, currentPage) {
      return {
        "bg-blue-500 text-white": page === currentPage,
        "bg-gray-300 text-gray-700 hover:bg-gray-400": page !== currentPage,
        "p-2 rounded-md mx-1": true, // Adjust padding and rounding based on your design
      };
    },

    goToPage(page) {
      // Implement your logic to update the current page
      //update page
      this.serverOptions.page = page;
      this.loadFromServer();
    },
    async loadFromServer() {
      this.loading = true;

      var tempObj = { ...this.serverOptions };
      //add new field to object search
      tempObj.search = this.$store.state.waste_item.search;

      const res = await this.$store.dispatch("waste_item/getItems", tempObj);

      this.items = res.data.data;
      this.serverItemsLength = res.data.total;
      this.loading = false;
    },
    updateSelectedItem(value) {
      this.purchases = [];
      // value is the selected id (string) from DropdownInput
      if (!value) return;
      this.getPurchases();
    },
    formatNumber(number) {
      return formatNumber(number);
    },
    formatDate(date) {
      return formatDate(date);
    },
    getData() {
      this.$store.dispatch("waste_item/getItems");
    },
    async addSaleItem() {
      //check form validation
      if (this.$store.state.waste_item.isBtnLoading) return;

      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.wt_quantity, "add", this.rules).isError ||
        this.checkRulesIsError(this.wt_note, "add", this.rules).isError ||
        this.checkRulesIsError(this.i_id, "add", this.rules_dropdown).isError ||
        this.checkRulesIsError(this.cawt_id, "add", this.rules_dropdown).isError ||
        this.checkRulesIsError(this.pui_id, "add", this.rules_dropdown).isError
      ) {
        return;
      }

      this.$store.state.waste_item.isBtnLoading = true;
      var res = await this.$store.dispatch("waste_item/addNewItem", {
        wt_quantity: this.wt_quantity,
        wt_note: this.wt_note,
        i_id: this.i_id,
        cawt_id: this.cawt_id,
        pui_id: this.pui_id,
      });
      if (res.status == 200) {
        this.wt_quantity = "";
        this.wt_note = "";
      this.i_id = "";
        this.cawt_id = "";
        this.isSubmited = false;
        this.purchases = [];
      this.pui_id = "";
        this.$store.state.waste_item.isBtnLoading = false;
        this.loadFromServer();
      }
      this.isSubmited = false;
    },
    checkRulesIsError(value, type) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of this.rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.commit("waste_item/REMOVE_ITEM", id);
        await this.$store.dispatch("waste_item/deleteItem", id);
        this.loadFromServer();
      }
    },
    //edit
    async showModal(item) {
      this.current = item;
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (
        this.checkRulesIsError(this.current.wt_quantity, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(this.current.wt_note, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(
          this.current.cawt_id,
          "edit",
          this.rules_dropdown
        ).isError
      ) {
        return;
      }
      this.$store.state.waste_item.isBtnEditLoading = true;
      var res = await this.$store.dispatch("waste_item/editItem", {
        wt_id: this.current.wt_id,
        wt_note: this.current.wt_note,
        cawt_id: this.current.cawt_id,
      });

      this.isSubmitedEdit = false;
      this.$store.state.waste_item.isBtnEditLoading = false;
      if (res.status == 200) {
        this.$refs.editModal.hide();
        this.loadFromServer();
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
